import CardTask from "./card-task";
import Flex from "@components/ui-components/flex";
import { LoaderOverlay } from "@components/spinner";
import LoadingButton from "@components/ui-components/loading-button";
import { NoDataComponent } from "@components/no-data-component";
import UpsertTasks from "./upsert";
import size from "lodash/size";
import useTasks from "./use-tasks";
import { useTranslation } from "react-i18next";
import { ROW_PER_PAGINATION_OPTIONS } from "@src/utility/constants";
import Paginate from "@src/@core/components/ui-components/paginate";

const Tasks = () => {
    const {
        data: { tasks, pagination },
        loading,
        handleRowActions,
        getTasks,
        modalConfig,
        handleModalConfig,
        handlePagination
    } = useTasks();
    const { t } = useTranslation();
    return (
        <>
            <Flex justify="between" className="mb-1 border-bottom pb-1">
                <h4>{t("Tasks")}</h4>
                <LoadingButton
                    color="primary"
                    icon="plus"
                    onClick={() => handleRowActions({}, "add")}
                    subject="companies"
                    action="create"
                    text="Add Task"
                    className="details-page-add-button"/>
            </Flex>
            <LoaderOverlay
                active={loading}
                children={
                    size(tasks) ? (
                        <>
                            {tasks.map(task => (
                                <CardTask
                                    task={task}
                                    handleRowActions={handleRowActions}/>
                            ))}
                        </>
                    ) : (
                        <NoDataComponent />
                    )
                }/>
            {size(tasks) > 0 && (
                <div className="mt-1">
                    <Paginate
                        paginationRowsPerPageOptions={ROW_PER_PAGINATION_OPTIONS}
                        handlePageChange={(page) => handlePagination({ page, limit: pagination?.limit || 10 })}
                        currentPage={pagination?.page}
                        handleLimit={(limit) => handlePagination({ limit, page: 1 })}
                        totalRecords={pagination?.totalRecords}
                        {...pagination}/>
                </div>
            )}
            <UpsertTasks
                handleModalConfig={handleModalConfig}
                modalConfig={modalConfig}
                getTasks={getTasks}/>
        </>
    );
};

export default Tasks;